import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import { MarcasItem } from '../../components/Marcas/MarcasItem'

import './Marcas.css'

function Marcas() {
  const API_URL = process.env.REACT_APP_API_URL

  const [marcas, setMarcas] = useState('')

  const [showNewMarca, setShowNewMarca] = useState('')
  const handleCloseNewMarca = () => setShowNewMarca(false)
  const handleShowNewMarca = () => setShowNewMarca(true)

  const [deleteMarcaId, setDeleteMarcaId] = useState('')
  const [showDeleteMarca, setShowDeleteMarca] = useState(false)
  const handleCloseDeleteMarca = () => setShowDeleteMarca(false)
  const handleShowDeleteMarca = (idElement) => {
    setShowDeleteMarca(true)
    setDeleteMarcaId(idElement)
  }
  

  const getMarcas = () => {
    axios
      .get(API_URL + '/marcas')
      .then((response) => {
        let marcas = response.data.data
        setMarcas(marcas)
        console.log(marcas)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadNuevaMarca = () => {
    const data = new FormData()

    data.append('id', '')
    data.append('name', '')
    data.append('marcaName', document.getElementById('nueva-marca-nombre').value)

    if (document.getElementById('nueva-marca-principal').files.length !== 0) {
      for (let i = 0; i < document.getElementById('nueva-marca-principal').files.length; i++) {
        data.append('file[]', document.getElementById('nueva-marca-principal').files[i])
      }
      data.append('principalExists', true)
    }

    if (document.getElementById('nueva-marca-blanco').files.length !== 0) {
      for (let i = 0; i < document.getElementById('nueva-marca-blanco').files.length; i++) {
        data.append('file[]', document.getElementById('nueva-marca-blanco').files[i])
      }
      data.append('blancoExists', true)
    }

    if (document.getElementById('nueva-marca-negro').files.length !== 0) {
      for (let i = 0; i < document.getElementById('nueva-marca-negro').files.length; i++) {
        data.append('file[]', document.getElementById('nueva-marca-negro').files[i])
      }
      data.append('negroExists', true)
    }

    axios.post(API_URL + '/new-marca', data, {}).then(
      (res) => {
        setMarcas(res.data.data)
        handleCloseNewMarca()
      },
      (error) => {
        alert(error)
      }
    )
  }

  const deleteMarca = (idElement) => {
    const data = {
      name: idElement,
    }

    axios.post(API_URL + '/delete-marca', data, {}).then(
      (res) => {
        setMarcas(res.data.data)
        handleCloseDeleteMarca()
      },
      (error) => {
        alert(error)
      }
    )
  }

  useEffect(() => {
    getMarcas()
  }, [])

  return (
    <div className='row g-5'>
      {/* MARCAS */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 marcas-home'>
          <div className='card-header'>
            <h3 className='card-title'>Marcas</h3>
            <p>
              <h5 className='card-subtitle'>Imagen principal:</h5>
              <span>No incluir el logo de la marca en la imagen</span><br /><br/>
              <span><b>Dimensiones: </b>700px de ancho por 500px de alto (o proporcional)</span><br />
              <span><b>Peso máximo permitido: </b>600kb</span><br />
              <span><b>Formato: </b>JPG o PNG</span><br />
            </p>

            <p>
              <br/><br/>
              <h5 className='card-subtitle'>Logos:</h5>
              <span>Los logos en blanco y negro debe ser del mismo tamaño</span><br /><br/>
              <span><b>Dimensiones: </b>minimo 250px de alto, por lo que dé de ancho</span><br />
              <span><b>Peso máximo permitido: </b>600kb</span><br />
              <span><b>Formato: </b>PNG con transparencia</span><br />
            </p>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary fw-bold text-light-dark mt-n20 mb-10'
                onClick={handleShowNewMarca}
              >
                Agregar
              </button>
            </div>
          </div>

          <div className='card-body'>
            <div className='row'>
              <MarcasItem marcas={marcas} deleteMarca={handleShowDeleteMarca}/>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showNewMarca} onHide={handleCloseNewMarca} className='modal-new-marca'>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Marca</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='form-group col-md-10 mb-2'>
            <label>Nombre:</label>
            <input type='text' className='form-control' id='nueva-marca-nombre' />
          </div>
          <div className='form-group col-md-10 mb-2'>
            <label>Imagen principal:</label>
            <input
              type='file'
              className='form-control'
              accept='image/*'
              id='nueva-marca-principal'
            />
          </div>
          <div className='form-group col-md-10 mb-2'>
            <label>Logo blanco:</label>
            <input type='file' className='form-control' accept='image/*' id='nueva-marca-blanco' />
          </div>
          <div className='form-group col-md-10 mb-2'>
            <label>Logo negro:</label>
            <input type='file' className='form-control' accept='image/*' id='nueva-marca-negro' />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewMarca}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNuevaMarca()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteMarca} onHide={handleCloseDeleteMarca} className='modal-delete-marca'>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar marca</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Seguro que desea eliminar la marca?</p>
          <p>Esta acción no puede deshacerse</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteMarca}>Cerrar</button>
          <button type='button' className='btn btn-danger' onClick={() => deleteMarca(deleteMarcaId)}>Eliminar</button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export {Marcas}
